module.exports = __webpack_public_path__ + "static/img/icon_hw.8dcac32.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/icon_hw.png
// module id = gZ+0
// module chunks = 1